import { IconType } from 'react-icons';
import { PiBookOpenTextBold } from 'react-icons/pi';
import { FEED_MORPHER, PARTNER_SETUP } from '../../routes/links';

interface InfoOverlayLinkBase {
  label: string;
  icon: IconType;
}

export interface InfoOverlayInternalLink extends InfoOverlayLinkBase {
  to: string;
  href?: never;
}

export interface InfoOverlayExternalLink extends InfoOverlayLinkBase {
  href: string;
  to?: never;
}

export type InfoOverlayLink = InfoOverlayInternalLink | InfoOverlayExternalLink;

export interface InfoOverlayRule {
  path: string;
  exact?: boolean;
  links: InfoOverlayLink[];
}

export const INFO_OVERLAY_VISIBLE: boolean = process.env.REACT_APP_INFO_OVERLAY_VISIBLE === 'true';

const FEED_KNOWLEDGE_BASE_LINK: InfoOverlayExternalLink = {
  label: 'Knowledge base',
  href: process.env.REACT_APP_FEED_KNOWLEDGE_BASE_URL ?? '',
  icon: PiBookOpenTextBold,
};

const INFO_OVERLAY_RULES: InfoOverlayRule[] = [
  {
    path: FEED_MORPHER,
    exact: true,
    links: [FEED_KNOWLEDGE_BASE_LINK],
  },
  {
    path: `${PARTNER_SETUP}/feed`,
    exact: true,
    links: [FEED_KNOWLEDGE_BASE_LINK],
  },
];

export default INFO_OVERLAY_RULES;
